export default "__VITE_ASSET__1d1fd4d4__"